import EmptyStatesPreview from '../content/EmptyStatesPreview'
import { Dash } from '@eggplant/pattern-library/src/lib/components/Artwork/Artwork'
import { LinkToMonitorPerformanceDashboardDoc } from '../links'
import { MonitorConfigConsumer } from '@eggplant/context'
import { SelectModelSuiteMonitorConfigs } from '@eggplant/input-controls'

const description = `Monitor performance breaks down the test cases in your selected monitor configuration, showing the runtime data of it’s test case steps over a specific period.

📝 Add monitor configurations and run them to see their data.`

const renderButton = () =>
  <MonitorConfigConsumer>
    {
      ({
        selectedMonitorConfigId,
        setSelectedMonitorConfigId
      }) =>
        <SelectModelSuiteMonitorConfigs
          onChange={setSelectedMonitorConfigId}
          placeholder='Monitor Config'
          shortErrorMessage='Failed to load monitor configs'
          value={selectedMonitorConfigId || ''}
        />
    }
  </MonitorConfigConsumer>

const MonitorPerformanceDashboardIntro = () =>
  <div className='grid h-full justify-center'>
    <div className='grid w-[36em]'>
      <EmptyStatesPreview
        action={renderButton()}
        description={description}
        icon={<Dash />}
        renderLink={<LinkToMonitorPerformanceDashboardDoc />}
        title='Monitor Performance'
      />
    </div>
  </div>

export default MonitorPerformanceDashboardIntro
